import { instance } from '@/api';

enum InquiryType {
  Site = 'site',
  Ads = 'ads',
}

interface InquiryCreate {
  type: InquiryType;
  name: string;
  email: string;
  contact: string;
  title: string;
  contents: string;
}

interface InquiryT {
  id:number;
  name: string;
  email:string;
  contact?: string;
  title: string;
  contents: string;
  reply:any;
  created_at:string;
  updated_at:string;
  user_id:number;
}

const fetchInquiryCreate = async (params: InquiryCreate) => {
  const { data } = await instance.post('/cs/inquiries', params);
  return data;
};

const fetchInquiries = async (page: number) => {
  const { data } = await instance.get(`/cs/inquiries?page=${page}`);
  return data;
};

const fetchInquiry = async (id: number) => {
  const { data } = await instance.get(`/cs/inquiries/${id}`);
  return data;
};

export { InquiryType, fetchInquiryCreate, fetchInquiries, fetchInquiry };
export type { InquiryCreate ,InquiryT};
